import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setHasShared } from "../redux/actionCreators/makeActionCreator";
import { TextField } from "@mui/material";
import Button from "../components/common/Button";
import { posthog } from "posthog-js";

function TextShare({ link, inDrawer }) {
  const [smsMsg, setSmsMsg] = useState(
    "I love Gainful and think you would too! Gainful offers personalized supplements formulated for your body, exercise, preferences, and evolving fitness goals. Intrigued? Take the quiz today to find the right personalized system for you—including Protein (choose from whey, soy-free, vegan, and gluten-free options), Pre-Workout, and Hydration—and get 40% off your first purchase."
  );
  const dispatch = useDispatch();

  return (
    <>
      <TextField
        multiline
        style={{ width: "100%", marginBottom: "24px" }}
        id="emailMsg"
        value={smsMsg}
        onChange={(e) => setSmsMsg(e.target.value)}
        label="Message"
      />
      <Button
        variant="primary"
        color="info"
        onClick={() => {
          dispatch(setHasShared(true));
          posthog?.capture("referred_by_text", { logged_in: true });
          if (!inDrawer) {
            window.scrollTo({ top: 0 });
          }
        }}
        href={`sms:&body=${smsMsg} ${link}`}
      >
        Send Text
      </Button>
    </>
  );
}

export default TextShare;
